<template>
    <el-image :fit="fit" :class="{'maximgae':(iswidth)}" :src="src" :lazy="lazy" :preview-src-list="previewsrclist">
        <div class="image-error" slot="error" style="height: inherit;">
            <div class="loadEffect1">
                <img :src="defaultImgUrl" />
                <!-- <div class="loading"></div> -->
            </div>
        </div>
        <div class="image-loader" slot="placeholder" v-if="isloading">
            <div class="loadEffect">
                <div class="loading"></div>
            </div>
        </div>
    </el-image>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    props:{
        src: {
            type: String,
            default: ''
        },
        lazy:{
            type:Boolean,
            default:false
        },
        iswidth:{
            type:Boolean,
            default:false
        },
        fit:{
            type:String,
            default: 'cover'
        },
        previewsrclist:{
            type:Array,
            default:function(){return []}
        },
        isloading:{
            type:Boolean,
            default:true
        },
        defaultImgUrl: {
            type:String,
            default: require('@/assets/default_img_banner@3x.png')
        }
    },
    methods:{

    }
}
</script>

<style lang="scss" scoped>
    .el-image{
        width: 100%;
        position: relative;
        /deep/ img{
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
        }
        &.maximgae{
            height: 100%;
            /deep/ img{
                width: 100%;
                height: 100%;
            }
        }
    }
    .image-error {
        min-width: 80px;
        min-height: 80px;
        height: 100%;
    }
    .image-loader {
        min-width: 80px;
        min-height: 80px;
    }
</style>
<style>
.loadEffect1 {
    width: 100%;
    height: 100%;
    background: white;
}
.loadEffect{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%,-50%,0);
        z-index: 2002;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 4px 10px rgb(105 105 105 / 20%);
        padding: 5px;
        border-radius: 50%;
        background: #fff;
    }
    .loadEffect .loading{
        width: 30px;
        height: 30px;
        display: inline-block;
        border: 3px solid #fff;
        background: #fff;
        border-radius: 50%;
        border-top: 3px solid #B0294A;
    }
    /* 定义动画 */
    @keyframes loadingAnimation{
        /* 动画开始旋转0度 */
        0%{
            transform: rotate(0deg);
        }
        /* 动画结束旋转360度 */
        100%{
            transform: rotate(360deg);
        }
    }
    /* 添加动画 */
    .loadEffect .loading{
        animation: loadingAnimation 2s infinite linear;
    }
</style>



// WEBPACK FOOTER //
// src/components/images.vue